 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT01_COVER from '@/components/text/01_cover'
 import TEXT02_HALFTITLEPAGE from '@/components/text/02_halftitlepage'
 import TEXT02A_OTHER from '@/components/text/02a_other'
 import TEXT03_TITLEPAGE from '@/components/text/03_titlepage'
 import TEXT04_COPYRIGHTPAGE from '@/components/text/04_copyrightpage'
 import TEXT05_TOC from '@/components/text/05_toc'
 import TEXT05A_AUTHOR from '@/components/text/05a_author'
 import TEXT07_PART1 from '@/components/text/07_part1'
 import TEXT08_CHAPTER1 from '@/components/text/08_chapter1'
 import TEXT09_CHAPTER2 from '@/components/text/09_chapter2'
 import TEXT10_CHAPTER3 from '@/components/text/10_chapter3'
 import TEXT11_EPILOGUE from '@/components/text/11_epilogue'
 import TEXT12_MATERIALSANDTOOLS from '@/components/text/12_materialsandtools'
 import TEXT13_FURTHERREADING from '@/components/text/13_furtherreading'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/05_toc",
 			"name" : "text/05_toc",
 			"component" : TEXT05_TOC
 		},
 		{
 			"path" : "/text/05a_author",
 			"name" : "text/05a_author",
 			"component" : TEXT05A_AUTHOR
 		},
 		{
 			"path" : "/text/07_part1",
 			"name" : "text/07_part1",
 			"component" : TEXT07_PART1
 		},
 		{
 			"path" : "/text/08_chapter1",
 			"name" : "text/08_chapter1",
 			"component" : TEXT08_CHAPTER1
 		},
 		{
 			"path" : "/text/09_chapter2",
 			"name" : "text/09_chapter2",
 			"component" : TEXT09_CHAPTER2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js